import DataCacheService from '@/services/DataCacheService'

export const cache = {
  namespaced: true,
  actions: {

    limparCache ({ dispatch }) {
      return DataCacheService.limparCache()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    limparChave ({ dispatch }, chave) {
      return DataCacheService.limparChave(chave)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarCache ({ dispatch }) {
      return DataCacheService.buscarCache()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
  },
  state: {},
  mutations: {},
}
